import { TableCellsIcon, ViewColumnsIcon } from "@heroicons/react/24/outline";

import { classNames } from "../../../common/lib/classNames";

interface InvoiceViewToggleProps {
  value: `table` | `board`;
  onChange: (value: `table` | `board`) => void;
}

export function InvoiceViewToggle({ value, onChange }: InvoiceViewToggleProps) {
  const options = [
    {
      key: `table` as const,
      label: `List`,
      Icon: TableCellsIcon,
    },
    {
      key: `board` as const,
      label: `Aging Buckets`,
      Icon: ViewColumnsIcon,
    },
  ];

  return (
    <div
      className={ `border-b border-gray-200` }
      role={ `tablist` }
      aria-label={ `Invoice view` }
    >
      <nav className={ `-mb-px flex space-x-6` }>
        { options.map(option => {
          const isSelected = value === option.key;

          return (
            <button
              key={ option.key }
              type={ `button` }
              role={ `tab` }
              onClick={ () => onChange(option.key) }
              className={ classNames(
                `group inline-flex items-center border-b-2 px-1 py-2.5 text-sm font-medium transition-colors duration-150 motion-reduce:transition-none`,
                `focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-paidniceGreen-500 focus-visible:ring-offset-1`,
                isSelected
                  ? `border-paidniceGreen-500 text-paidniceGreen-600`
                  : `border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700`,
              ) }
              aria-selected={ isSelected }
            >
              <option.Icon
                className={ classNames(
                  `mr-2 h-4 w-4`,
                  isSelected
                    ? `text-paidniceGreen-500`
                    : `text-gray-400 group-hover:text-gray-500`,
                ) }
                aria-hidden={ `true` }
              />
              <span>{ option.label }</span>
            </button>
          );
        }) }
      </nav>
    </div>
  );
}
